<nav class="menu">
    <h4 class="menu__title">On this page</h4>
    <ul>
        <li class="menu__option">
            <!-- <button class="menu__btn">Profile settings</button> -->
            <ul class="menu__sub-menu">
                <ng-container *ngIf="menuItems.hasParents; else noChildsMenu">
                    <li class="menu__sub-menu__parent">
                        <a
                        [routerLink]="menuItems.mainPath.path" 
                        routerLinkActive="current" 
                        [routerLinkActiveOptions]="{ exact: true }"                    
                        >{{menuItems.mainPath.title}}</a>                        
                    </li>              
                    <ng-container *ngFor="let item of menuItems.items">
                        <li class="menu__sub-menu__child"><a 
                            [routerLink]="item.path" 
                            routerLinkActive="current" 
                            [routerLinkActiveOptions]="{ exact: true }"
                            >{{ item.title }}</a></li>
                        <li>
                    </ng-container>
                </ng-container>
            </ul>
        </li>
        <!-- <li class="menu__option">
            <button class="menu__btn">Othear option</button>
        </li> -->
    </ul>
</nav>

<ng-template #noChildsMenu>
    <ng-container *ngFor="let item of menuItems.items">
        <li class="menu__sub-menu__parent"><a 
            [routerLink]="item.path" 
            routerLinkActive="current" 
            [routerLinkActiveOptions]="{ exact: true }"
            >{{ item.title }}</a></li>
        <li>
    </ng-container>  
</ng-template>